import React, { useState, useEffect } from 'react';
import ProgressBar from '@fuww/library/src/ProgressBar';
import { progressListeners } from '../../../lib/progress';

export const getVariant = (progress: number) => (progress === 100
  ? 'indeterminate' : 'determinate');

const UploadProgress = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const progressListener = (percent: number) => setProgress(percent);
    progressListeners.push(progressListener);

    return () => {
      progressListeners.splice(progressListeners.indexOf(progressListener));
    };
  }, []);

  return (
    <ProgressBar
      value={progress}
      variant={getVariant(progress)}
    />
  );
};

export default UploadProgress;
